<template>
  <!-- 运力商干线订单详情 MainOrdersDetail-->
  <div class="main-orders-detail padding">
    <div class="entrust-information">
      <h3>委托信息</h3>
      <el-row :gutter="20" class="entrust-information-detail">
        <el-col :span="6">
          <div class="information-ground">
            <span class="label">主单号</span>
            <span>{{ orderInfor.orderNo }}</span>
          </div>
          <div class="information-ground">
            <span class="label">预报总重量(KG)</span>
            <span>{{ orderInfor.allWeight }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="information-ground">
            <span class="label">物流产品</span>
            <span>{{ orderInfor.productName }}</span>
          </div>
          <div class="information-ground">
            <span class="label">预报总体积(CBM)</span>
            <span>{{ orderInfor.allCbm }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="information-ground">
            <span class="label">运输方式</span>
            <span>{{ orderInfor.transportType }}</span>
          </div>
          <div class="information-ground">
            <span class="label">预报总箱数</span>
            <span>{{ orderInfor.boxNum }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="information-ground">
            <span class="label">下单时间</span>
            <span>{{ orderInfor.inputtime }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-row class="flex justify-between align-center margin-top-lg">
      <el-col :span="8" class="cargo-item">
        <div class="title">
          <i
            class="el-icon-truck"
            style="font-size: 22px; color: rgb(230, 162, 60)"
          ></i>
          <span style="margin-left: 5px">发货信息</span>
        </div>
        <div class="content">
          <p>
            <span>发货仓：</span>
            <span>{{
              orderInfor.deliveryInformationDTO.deliveryWarehouse
            }}</span>
          </p>
          <p>
            <span>发货人：</span>
            <span
              >{{ orderInfor.deliveryInformationDTO.deliveryPerson }}/{{
                orderInfor.deliveryInformationDTO.deliveryTel
              }}</span
            >
          </p>
          <p>
            <span>仓库地址：</span>
            <span>{{ orderInfor.deliveryInformationDTO.deliveryWarehouse}}</span>
          </p>
        </div>
      </el-col>
      <el-col :span="8" class="transition padding-left padding-right">
        <div class="flex justify-center align-center">
          <div class="bottom-arrow-right-content">
<!--            <div>市内配送商：</div>-->
<!--            <div>-->
<!--              {{ orderInfor.cityCarrierDTO.carrierName }}/{{-->
<!--                orderInfor.cityCarrierDTO.carrierTel-->
<!--              }}-->
<!--            </div>-->
            <div class="margin-top-xl flex justify-center align-center">
              <span class="sort-down-ground">
                <i class="sort-arrow"></i>
              </span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8" class="cargo-item">
        <div class="title">
          <i
            class="el-icon-s-home"
            style="font-size: 22px; color: rgb(64, 158, 255)"
          ></i>
          <span style="margin-left: 5px">收货信息</span>
        </div>
        <div class="content">
          <p>
            <span>收货仓：</span>
            <span>{{
              orderInfor.receivingInformationDTO.receivingWarehouse
            }}</span>
          </p>
          <p>
            <span>仓库联系人：</span>
            <span
              >{{ orderInfor.receivingInformationDTO.receivingPerson }}/{{
                orderInfor.receivingInformationDTO.receivingTel
              }}</span
            >
          </p>
          <p>
            <span>仓库地址：</span>
            <span>{{ orderInfor.receivingInformationDTO.receivingAddressc }}</span>
          </p>
        </div>
      </el-col>
    </el-row>
    <div class="tabs">
      <!-- <div class="btn" @click="centerDialogVisible = true">
        <el-button size="small" type="success">批量导入</el-button>
      </div> -->

      <el-tabs v-model="activeName" type="border-card">
        <!-- <el-tab-pane label="入仓确认商品信息" name="0">

          <giowc
            v-if="enterType === 'readonly'"
            :inWarehouseDetailOrderDTO="orderInfor.inWarehouseDetailOrderDTO"
          ></giowc>
          <giow-confirm
            v-else
            :inWarehouseOrderFeeDTO="orderInfor.inWarehouseOrderFeeDTO"
            :orderId="orderId"
            @getinwarehouseorderfeedto="getinWarehouseOrderFeeDTO"
          ></giow-confirm>
        </el-tab-pane> -->
        <el-tab-pane label="预报单商品详情" name="1">
          <fid :beforeDetailOrdersDTO="orderInfor.beforeDetailOrdersDTO"></fid>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="mr-top-80">
      <router-link :to="{ path: 'mainOrdersList' }">
        <el-button type="info">返回</el-button></router-link
      >

      <el-button
        v-if="enterType !== 'readonly'"
        type="primary"
        @click="handlerConfirm"
        >确认入仓</el-button
      >
    </div>

    <el-dialog title="" :visible.sync="centerDialogVisible" width="30%" center>
      <order-import></order-import>

      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import EnterStorage from "./components/enter-storage";

import Giowc from "./components/Giowc.vue";
import GiowConfirm from "./components/GiowConfirm.vue";
import Fid from "./components/Fid.vue";
import OrderImport from "./components/OrderImport.vue";
export default {
  components: {
    EnterStorage,
    Giowc,
    GiowConfirm,
    Fid,
    OrderImport,
  },
  data() {
    return {
      entrustInformation: {},
      enterStorageTabIndex: 0,
      enterStorageList: [
        {
          tableData: [
            {
              shopName: "",
              fbxbox: "1222",
              poTrackingNo: "",
              length: "4555",
              width: "558",
              height: "665",
              weight: "12",
            },
          ],
          productList: [
            // {
            //   name: '收到贵司的',
            //   prop: ['price', 'number'],
            //   number: '',
            //   price: ''
            // }
          ],
        },
      ],
      predictionTableData: [
        {
          no: "445455",
          name: "445455",
          address: "445455",
        },
        {
          no: "445455",
          name: "445455",
          address: "445455",
        },
      ],
      enterType: "readonly",
      orderId: "",

      orderInfor: {
        orderNo: "",
        allWeight: 0,
        productName: "",
        allCbm: 0,
        transportType: "",
        boxNum: "",
        inputtime: "",
        deliveryInformationDTO: {
          deliveryWarehouse: "",
          deliveryPerson: "",
          deliveryTel: "",
        },
        cityCarrierDTO: {
          carrierName: "",
          carrierTel: "",
        },
        receivingInformationDTO: {
          receivingPerson: "",
          receivingWarehouse: "",
          receivingTel: "",
        },
        inWarehouseDetailOrderDTO: {},
        beforeDetailOrdersDTO: {},
        inWarehouseOrderFeeDTO: {},
      },
      activeName: "1",
      centerDialogVisible: false,
    };
  },
  computed: {
    isOperate() {
      //readonly不是查看时可编辑
      return this.enterType !== "readonly";
    },
  },
  created() {
    this.orderId = this.$route.query.orderId;

    this.enterType = this.$route.query.enterType;
    if (this.enterType === "readonly") {
      this.getDetail(this.orderId);
    } else {
      this.getInwarehouseOrderDetailInfo();
    }
  },
  methods: {
    getDetail() {
      this.axios
        .get(`/carrier/order/getMainOrderDetailInfo/${this.orderId}`)
        .then((res) => {
          const { data } = res.data;
          this.orderInfor = data;

          // let result = res.data.data
          // console.log('result: ', result)
        });
    },
    getInwarehouseOrderDetailInfo() {
      this.axios
        .get(`/carrier/order/getInwarehouseOrderDetailInfo/${this.orderId}`)
        .then((res) => {
          const { data } = res.data;

          this.orderInfor = data;

          // let result = res.data.data
          // console.log('result: ', result)
        });
    },
    enterStorageTabChange(index) {
      this.enterStorageTabIndex = index;
    },
    back() {
      this.$router.go(-1);
    },
    save() {
      console.log("data: ", 999);
    },
    query(item) {
      // 查看
      console.log("item: ", item);
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 6) {
          sums[index] = "折算人民币：";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (index === 7) {
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = "￥ " + sums[index];
          }
        }
      });

      return sums;
    },

    getinWarehouseOrderFeeDTO(val) {
      // 回选子组件的数据

      this.orderInfor.inWarehouseOrderFeeDTO = val;
    },
    handlerConfirm() {
      this.axios
        .post(`/carrier/order/confirmInWarehouse`, this.orderInfor)
        .then( (res) => {
          console.log('res' , res)
          if (res.data.code === 200) {
            this.$confirm('入仓成功！','入仓成功！',{
              showCancelButton:false,
            }).then(()=>{
              this.$router.push({ path: "mainOrdersList" });
            });
          } else {
            this.$message({
              message: "入仓失败！",
              type: "error",
            });
          }
        });
    },
  },
};
</script>

<style  scoped>
.main-orders-detail .entrust-information h3 {
  margin-top: 20px;
  margin-bottom: 20px;
  color: rgb(148, 148, 148);
}
.entrust-information-detail .information-ground {
  margin-bottom: 16px;
}
.entrust-information-detail .information-ground span {
  color: #333;
}
.entrust-information-detail .information-ground .label {
  color: rgb(204, 204, 204);
  margin-right: 20px;
}
.cargo-item {
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}
.cargo-item .title {
  border-bottom: 1px solid #ebeef5;
  height: 50px;
  padding: 12px 20px;
  box-sizing: border-box;
}
.cargo-item .content {
  padding: 20px 30px 30px;
  box-sizing: border-box;
  color: rgb(204, 204, 204);
}
.transition .el-icon-sort-down {
  font-size: 150px;
  color: rgb(64, 158, 255);
  transform: rotate(90deg);
}

.enter-storage-content {
  box-sizing: border-box;
  margin-top: 30px;
  border: 1px solid #ebeef5;
  border-radius: 10px;
}
.enter-storage-content .title {
  box-sizing: border-box;
  border-bottom: 1px solid #ebeef5;
}
.enter-storage-content h3 {
  margin: 0;
}
.enter-storage-content h3::before {
  content: "";
  width: 0;
}
.enter-storage-content .carriage {
  width: 400px;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  padding: 5px 20px;
  overflow: hidden;
}
.carriage .left {
  text-align: center;
  background-color: #f5f7fa;
  margin: -5px 0 -5px -20px;
  padding: 5px 20px;
  border-right: 1px solid #dcdfe6;
}
.carriage .middle {
  color: #333;
  padding-left: 10px;
  font-size: 14px;
}
.carriage .right {
  text-align: left;
  background-color: #f5f7fa;
  margin: -5px -20px -5px 0;
  padding: 5px 20px;
  border-left: 1px solid #dcdfe6;
  position: relative;
  cursor: pointer;
}
.carriage .right .el-icon-arrow-down {
  position: absolute;
  top: calc(50% - 7px);
  right: 10px;
  color: rgb(204, 204, 204);
}
.enter-storage-content .carriage span {
  font-size: 13px;
  color: #909399;
}
.enter-storage-content .carriage span.total {
  color: orange;
  margin-left: 5px;
  margin-right: 5px;
}
.enter-storage-content .tabs-ground .tab {
  box-sizing: border-box;
  padding-left: 10px;
  padding-right: 10px;
  height: 100%;
  padding: 10px 20px;
  text-align: center;
  border-right: 1px solid #ebeef5;
  cursor: pointer;
}
.enter-storage-content .tabs-ground .tab:first-child {
  border-left: 1px solid #ebeef5;
  border-top-left-radius: 10px;
  margin-left: -1px;
}
.enter-storage-content .tabs-ground .tab:last-child {
  border-right: 1px solid #ebeef5;
  border-top-right-radius: 10px;
}
.enter-storage-content .tabs-ground .tab.active {
  height: calc(100% + 1px);
  border-bottom: 1px solid #fff;
  z-index: 10;
  background-color: #fff;
  margin-bottom: -1px;
  color: rgb(64, 158, 255);
}
.bottom-arrow-right-content {
  color: rgb(204, 204, 204);
  font-size: 16px;
}
.sort-down-ground .sort-arrow {
  display: block;
  width: 150px;
  height: 10px;
  background-color: rgb(64, 158, 255);
  position: relative;
  border-radius: 5px;
}
.sort-down-ground .sort-arrow::after {
  content: "";
  position: absolute;
  bottom: 20px;
  right: -6px;
  display: block;
  width: 60px;
  height: 10px;
  border-radius: 5px;
  background-color: rgb(64, 158, 255);
  transform: rotate(45deg);
}
.detail-right h4 {
  color: rgb(148, 148, 148);
  margin-bottom: 10px;
}

/* Sima thief */
</style>
<style lang="scss" scoped>
@import "./styles/index.scss";
.tabs {
  margin-top: 20px;
  position: relative;
}
.mr-top-80 {
  text-align: center;
}
.btn {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/mainOrders/main-orders-detail.vue